import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardTitle, Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import { ErrorToaster, successToaster } from "components/common/toast";
import { GetCampaignsAPI, GetCustomersCsvAPI, GetPromotionsAPI, SaveCampaignAPI } from "network/orders";
import { errText } from "views/bookings/Agenda";

const Campaign = ({ c, promos, onSaved }) => {
  const { t } = useTranslation("orders");
  const [message, setMessage] = useState(c.message);
  const [promo, setPromo] = useState(c.promotion_id || "");
  const save = async (extra = {}, ok = t("campaigns.saved")) => {
    try {
      await SaveCampaignAPI(c.kind, { message, promotion_id: promo || null, ...extra });
      successToaster(ok);
      onSaved();
    } catch (e) {
      ErrorToaster(errText(e));
    }
  };
  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <CardTitle tag="h4" className="mb-1">{c.title}</CardTitle>
            <p className="text-muted mb-2">{c.description}</p>
          </div>
          <div className="text-right">
            <span className={`badge badge-${c.enabled ? "success" : "secondary"}`}>{c.enabled ? t("campaigns.on") : t("campaigns.off")}</span>
            <div className="small text-muted mt-1">{t("campaigns.sent30", { count: c.sent_30d })}</div>
          </div>
        </div>
        <label>{t("campaigns.message")}</label>
        <Input type="textarea" rows="3" value={message} placeholder={c.default_message} onChange={(e) => setMessage(e.target.value)} />
        <div className="small text-muted mb-3">{t("campaigns.placeholders")}</div>
        <label>{t("campaigns.promoToOffer")}</label>
        <Input type="select" value={promo} onChange={(e) => setPromo(e.target.value)} className="mb-3">
          <option value="">{t("campaigns.none")}</option>
          {promos.map((p) => <option key={p.id} value={p.id}>{p.name} · {p.text}{p.code ? ` (${t("campaigns.codeWord")} ${p.code})` : ""}</option>)}
        </Input>
        <Button color="primary" onClick={() => save()}>{t("save")}</Button>
        <Button color={c.enabled ? "default" : "success"} onClick={() => save({ enabled: !c.enabled }, c.enabled ? t("campaigns.turnedOff") : t("campaigns.turnedOn"))}>
          {c.enabled ? t("campaigns.turnOff") : t("campaigns.turnOn")}
        </Button>
      </CardBody>
    </Card>
  );
};

const Campaigns = () => {
  const { t } = useTranslation("orders");
  const [list, setList] = useState([]);
  const [promos, setPromos] = useState([]);
  const load = async () => {
    try {
      setList(await GetCampaignsAPI());
      setPromos(await GetPromotionsAPI());
    } catch (e) {
      ErrorToaster(errText(e));
    }
  };
  useEffect(() => {
    load();
  }, []);
  const exportCsv = async () => {
    try {
      const csv = await GetCustomersCsvAPI();
      const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = "clienti.csv";
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      ErrorToaster(errText(e));
    }
  };
  return (
    <>
      <Card>
        <CardBody>
          <CardTitle tag="h4">{t("campaigns.title")}</CardTitle>
          <p className="text-muted mb-2">
            {t("campaigns.intro")}
          </p>
          <Button size="sm" color="primary" onClick={exportCsv}>{t("campaigns.download")}</Button>
        </CardBody>
      </Card>
      {list.map((c) => <Campaign key={c.kind + c.enabled + c.message} c={c} promos={promos} onSaved={load} />)}
    </>
  );
};

export default Campaigns;
